import { useEffect, useState } from 'react';

/** Phone widths get the iPhone shell (tab bar, dock, More page). iPad and
 * desktop keep their own navigation from 768px up. */
export const PHONE_LAYOUT_QUERY = '(max-width: 767px)';

function matchesPhone(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(PHONE_LAYOUT_QUERY).matches;
}

export function usePhoneLayout(): boolean {
  const [phone, setPhone] = useState(matchesPhone);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(PHONE_LAYOUT_QUERY);
    const update = () => setPhone(query.matches);
    update();
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return phone;
}
